<!-- Header -->
<app-header [isAlerts]="isAlerts" [hideBackButton]="true"></app-header>

<!-- Main Content -->
<ion-content cdkScrollable #content class="gray-content-bg">
  <!-- Swiper Container -->
  <swiper-container
    #notiSwiperRef
    class="notifications-swiper-container"
    auto-height="true"
    no-swiping="true"
    initial-slide="1"
    observer="true"
    resize-observer="true"
    observe-parents="true"
    allow-touch-move="false"
    speed="0"
  >
    <!-- Alerts Slide -->
    <swiper-slide class="swiper-no-swiping">
      <ion-grid [fixed]="true" class="ion-no-padding">
        <ion-row class="ion-no-padding">
          <ion-col class="ion-no-padding">
            <!-- Alerts Virtual Scroll Viewport -->
            <cdk-virtual-scroll-viewport
              *ngIf="showViewport"
              #alertsList
              [hidden]="!this.isAlerts"
              itemSize="174"
              minBufferPx="1200"
              maxBufferPx="2400"
              appendOnly="true"
              class="gray-content-bg notifications-list"
              [ngClass]="platformService.platformType === platformService.platformEnum.desktop ? '' : 'list-mobile'"
              (scroll)="onCdkScroll($event)"
            >
              <div class="viewport-wrapper">
                <!-- Notifications Header -->
                <app-notifications-header
                  [isDesktop]="platformService.platformType === platformService.platformEnum.desktop"
                  [stickyHeader]="stickyHeader"
                  [allRead]="allRead"
                  [allReadTmNotes]="allReadTmNotes"
                  (openFilters)="openFilters()"
                  [hasFilters]="hasFilters"
                  (markAllAsRead)="markAllAsRead()"
                  [activeTab]="activeTab"
                  (switchTab)="switchTab($event)"
                  [unreadAlertCount]="unreadAlertsCount$ | async"
                  [unreadNoteCount]="unreadNotesCount$ | async"
                ></app-notifications-header>

                <!-- Action Buttons -->
                <ion-grid
                  [fixed]="true"
                  class="not-sticky-header-buttons"
                  *ngIf="!(stickyHeader && platformService.platformType === platformService.platformEnum.desktop)"
                >
                  <ion-row class="ion-align-items-center">
                    <ion-col class="ion-no-padding" size="8">
                      <!-- UPC Link (Mobile) -->
                      <div
                        *ngIf="platformService.platformType !== platformService.platformEnum.desktop && !isSuperUser"
                      >
                        <ion-label
                          data-cy="open-upc-mobile-button"
                          class="upc-link"
                          (click)="openUPC()"
                          translate
                        >
                          {{ 'i18n.common.preferenceCenter' }}
                        </ion-label>
                      </div>
                    </ion-col>
                    <div>
                      <!-- Filter Button -->
                      <ion-col size="auto" class="ion-no-padding">
                        <ion-button
                          data-cy="open-filters-button"
                          fill="clear"
                          [disabled]="(this.isAlerts && this.isLoadingAlerts)"
                          [ngClass]="
                        hasFilters ? 'usf-fill-green-button' : 'usf-outline-green-button'
                      "
                          (click)="openFilters()"
                        >
                          <ion-icon slot="start" name="filter"></ion-icon>
                          <ion-label translate
                            >{{ 'i18n.notifications.filter' }}</ion-label
                          >
                        </ion-button>
                      </ion-col>
                      <!-- Mark All Read Button (Desktop) -->
                      <ion-col
                        size="auto"
                        class="ion-no-padding"
                        *ngIf="platformService.platformType === platformService.platformEnum.desktop"
                      >
                        <ion-button
                          data-cy="mark-all-read-desktop-button"
                          fill="clear"
                          class="usf-outline-green-button mark-all-read-button"
                          [disabled]="(this.isAlerts && (this.allRead || this.isLoadingAlerts || !this.filteredNotifications)) || (!this.isAlerts && (this.allReadTmNotes || this.isLoadingTmNotes || !this.notesInView))"
                          (click)="markAllAsRead()"
                        >
                          <ion-label translate
                            >{{ 'i18n.notifications.markAllAsRead' }}</ion-label
                          >
                        </ion-button>
                      </ion-col>
                    </div>
                  </ion-row>
                </ion-grid>

                <!-- Notifications List -->
                <div class="viewport-content">
                  <!-- Loading Spinner -->
                  <div *ngIf="this.isLoadingAlerts" class="spinner-container">
                    <ion-spinner
                      data-cy="loading-spinner"
                      name="circles"
                    ></ion-spinner>
                  </div>

                  <!-- No Notifications Message -->
                  <div
                    data-cy="no-notifications-text"
                    *ngIf="!this.isLoadingAlerts && (!this.notifications || this.notifications.length === 0)"
                    class="no-content"
                  >
                    <p translate *ngIf="this.hasFilters">
                      {{'i18n.notifications.noNotificationsFound'}}
                    </p>
                    <p translate *ngIf="!this.hasFilters">
                      {{'i18n.notifications.noNotificationsAtThisTime'}}
                    </p>
                    <ion-button
                      data-cy="clear-filters-button"
                      *ngIf="this.hasFilters"
                      (click)="this.clearFilters()"
                      fill="clear"
                      translate
                      >{{ 'i18n.notifications.clearAllFilters' }}</ion-button
                    >
                  </div>
                  <ion-item
                    *cdkVirtualFor="let notification of filteredNotifications; trackBy: trackByFn; let i = index"
                    class="ion-no-padding gray-content-bg"
                    lines="none"
                  >
                    <app-notification-card
                      [notification]="notification"
                      (click)="doCTA(notification)"
                    ></app-notification-card>
                  </ion-item>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
          </ion-col>
        </ion-row>
      </ion-grid>
    </swiper-slide>

    <!-- TM Notes Slide -->
    <swiper-slide class="swiper-no-swiping">
      <ion-grid [fixed]="true" class="ion-no-padding">
        <ion-row class="ion-no-padding">
          <ion-col class="ion-no-padding">
            <!-- TM Notes Virtual Scroll Viewport -->
            <cdk-virtual-scroll-viewport
              *ngIf="showViewport"
              #tmNotesList
              [hidden]="this.isAlerts || this.tmNotes?.length === 0"
              itemSize="581"
              minBufferPx="1200"
              maxBufferPx="2400"
              class="gray-content-bg notifications-list"
              [ngClass]="platformService.platformType === platformService.platformEnum.desktop ? '' : 'list-mobile'"
              appendOnly="true"
              (scroll)="onCdkScroll($event)"
            >
              <div class="viewport-wrapper">
                <!-- TM Notes Header -->
                <app-notifications-header
                  [isDesktop]="platformService.platformType === platformService.platformEnum.desktop"
                  [stickyHeader]="stickyHeader"
                  [allRead]="allRead"
                  [allReadTmNotes]="allReadTmNotes"
                  (openFilters)="openFilters()"
                  [hasFilters]="hasFilters"
                  (markAllAsRead)="markAllAsRead()"
                  [activeTab]="activeTab"
                  (switchTab)="switchTab($event)"
                  [unreadAlertCount]="unreadAlertsCount$ | async"
                  [unreadNoteCount]="unreadNotesCount$ | async"
                ></app-notifications-header>

                <!-- Action Buttons -->
                <ion-grid
                  [fixed]="true"
                  class="not-sticky-header-buttons"
                  *ngIf="!(stickyHeader && platformService.platformType === platformService.platformEnum.desktop)"
                >
                  <ion-row class="ion-align-items-center">
                    <ion-col class="ion-no-padding" size="8">
                      <!-- UPC Link (Mobile) -->
                      <div
                        *ngIf="platformService.platformType !== platformService.platformEnum.desktop && !isSuperUser"
                      >
                        <ion-label
                          data-cy="open-upc-mobile-button"
                          class="upc-link"
                          (click)="openUPC()"
                          translate
                        >
                          {{ 'i18n.common.preferenceCenter' }}
                        </ion-label>
                      </div>
                    </ion-col>
                    <div>
                      <!-- Mark All Read Button (Desktop) -->
                      <ion-col
                        size="auto"
                        class="ion-no-padding"
                        *ngIf="platformService.platformType === platformService.platformEnum.desktop"
                      >
                        <ion-button
                          data-cy="mark-all-read-desktop-button"
                          fill="clear"
                          class="usf-outline-green-button mark-all-read-button"
                          [disabled]="(this.isAlerts && (this.allRead || this.isLoadingAlerts || !this.filteredNotifications)) || (!this.isAlerts && (this.allReadTmNotes || this.isLoadingTmNotes || !this.notesInView))"
                          (click)="markAllAsRead()"
                        >
                          <ion-label translate
                            >{{ 'i18n.notifications.markAllAsRead' }}</ion-label
                          >
                        </ion-button>
                      </ion-col>
                    </div>
                  </ion-row>
                </ion-grid>

                <!-- TM Notes List -->
                <div class="viewport-content">
                  <!-- Loading Spinner -->
                  <div *ngIf="this.isLoadingTmNotes" class="spinner-container">
                    <ion-spinner
                      data-cy="loading-spinner"
                      name="circles"
                    ></ion-spinner>
                  </div>

                  <!-- No TM Notes Message -->
                  <div
                    data-cy="no-tm-notes-text"
                    *ngIf="!this.isLoadingTmNotes && !this.tmNotes"
                    class="no-content"
                  >
                    <p translate>
                      {{'i18n.notifications.noNotificationsAtThisTime'}}
                    </p>
                  </div>
                  <ion-item
                    *cdkVirtualFor="let tmNote of notesInView; trackBy: trackByFn; let i = index"
                    class="ion-no-padding gray-content-bg tm-note-list-item"
                    lines="none"
                  >
                    <app-tm-note-card [tmNote]="tmNote"></app-tm-note-card>
                  </ion-item>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
          </ion-col>
        </ion-row>
      </ion-grid>
    </swiper-slide>
  </swiper-container>
</ion-content>

<!-- Footer -->
<app-footer class="footer" *ngIf="showFooter"></app-footer>

<!-- Mobile Mark All Read Button -->
<ion-button
  data-cy="mark-all-read-mobile-button"
  fill="clear"
  class="usf-fill-green-button mobile-mark-all-as-read"
  *ngIf="platformService.platformType !== platformService.platformEnum.desktop && ((this.isAlerts && this.notifications?.length > 0 && this.filteredNotifications) || (!this.isAlerts && this.tmNotes?.length > 0 && this.notesInView))"
  [disabled]="(this.isAlerts && this.allRead) || (!this.isAlerts && this.allReadTmNotes)"
  (click)="markAllAsRead()"
>
  <ion-label translate>{{'i18n.notifications.markAllAsRead'}}</ion-label>
</ion-button>

<!-- Floating Tooltip for Notifications -->
<div class="help-icon">
  <img
    data-cy="notifications-page-open-help-modal-button"
    src="assets/icon/custom-help-tooltip.svg"
    (click)="openHelpModal()"
    loading="lazy"
    width="40"
    height="40"
  />
</div>
